// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"d2711f62","453":"384a66da"}[chunkId] + ".chunk.js";
};